module.exports = __webpack_public_path__ + "img/img_hp_inquiry@2x.1fa64b90.png";